
import { Vue, Component, Emit, Mixins } from "vue-property-decorator"
import api from "../../honcierge-api"
import { AxiosError } from "axios"
import FrontUrlMixin from "../../mixins/front-url-mixins"

@Component
export default class Preview extends Mixins(FrontUrlMixin) {
  @Emit("finishPreview")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public finishPreview(messages?: string[]): void {
    /** */
  }

  protected postPreview(
    type: string,
    message: string,
    expiredTime?: number
  ): void {
    Vue.component("async-preview", (resolve) => {
      api
        .postPreview(type, expiredTime)
        .then((response) => {
          resolve({
            template:
              '<div><a target="_blank" rel="noopener noreferrer" href="' +
              this.previewUrl(response.data.key) +
              '">' +
              message +
              "</a></div>",
          })
          this.finishPreview()
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.finishPreview(e.response.data.messages)
          }
        })
    })
  }

  private previewUrl(previewKey: string): string {
    return `${this.frontOrigin}/preview?key=${previewKey}`
  }
}
